import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, Statistic, Progress } from "antd";
import moment from "moment";

import { secons2text } from "../../services/timeFunctions";

// Styles
import { Wrapper, H3 } from "./styles";

import Table from "../../components/table";
import Search from "../../components/table/search";

import Colors from "../../theme/colors";

// Hooks
import useManufacturingOrder from "../../hooks/useManufacturingOrder";
import useInterval from "../../hooks/useInterval";

//import multilanguage library
import { useTranslation } from "react-i18next";

const temperaturePrograming = 600;

const RenderTempered = (/*{quenchingStatus}*/) => {
  const [manufacturingList, setManufacturingList] = useState(null);
  const [availableArticle, setAvailableArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);

  const [furnaceNowTemperature /*setFurnaceNowTemperature*/] = useState(600);

  const { manufacturingOrder, updateData } = useManufacturingOrder();

  //To translate text
  const { t } = useTranslation();

  //To refresh time to out furnace
  useInterval(() => {
    //set same value
    setFurnaceArticle([...furnaceArticle]);
  }, 30000);

  /*useInterval(() => {
    if(furnaceNowTemperature < temperaturePrograming) {
      setFurnaceNowTemperature(prevState => prevState+10);
      //para mantener el efecto
      localStorage.setItem('furnaceTemp', furnaceNowTemperature);
    }
  }, 1000);

  useEffect(()=>{
    let temp = localStorage.getItem('furnaceTemp');
    if (temp) setFurnaceNowTemperature(parseInt(temp));
  },[])*/

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order,
      };
    });

    const availableList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        let a = {
          key: x + "-" + piece.id,
          ...piece,
          name: order.name,
          tempered: {
            time: order.desing.recommendation.tempered_time,
            temperature: order.desing.tempered.temperature,
            ...piece.tempered,
          },
        };
        if (!piece.tempered && piece.quenching && piece.quenching.end) availableList.push(a);
        if (piece.tempered && piece.tempered.start && !piece.tempered.end) intoFurnaceList.push(a);
      });
    });

    setAvailableArticle(availableList);
    setFurnaceArticle(intoFurnaceList);

    normalized && setManufacturingList(normalized);
  }, [manufacturingOrder]);

  const columnsOrders = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.article"),
      dataIndex: "article.name",
      key: "article.name",
    },
    {
      title: t("table.header.percent_pieces_tempered"),
      dataIndex: "pieces",
      key: "pieces",
      render: (text, record) => {
        if (!record.pieces) return;
        //Furnace end in each piece
        let ended = record.pieces.reduce((total, x) => (x.tempered && x.tempered.end ? total + 1 : total), 0);
        let percent = parseInt((100 * ended) / record.pieces.length);

        return (
          <div style={{ width: "100%" }}>
            <Progress percent={percent} size="small" />
          </div>
        );
      },
    },
  ];

  const columnsAvailable = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.furnace_temp"),
      dataIndex: "tempered.temperature",
      key: "tempered.temperature",
    },
    {
      title: t("table.header.action"),
      dataIndex: "tempered",
      key: "tempered",
      render: (text, record) => {
        return (
          <div
            style={
              {
                /*width: 170*/
              }
            }
          >
            <Button
              type="link"
              size="small"
              //disabled={!(record.tempered.temperature > furnaceNowTemperature - 10  && record.tempered.temperature < furnaceNowTemperature + 10 )}
              onClick={() => article2furnace(record.id, record.name)}
            >
              {t("button.action.to_furnace")}
              <Icon type="right" />
            </Button>
          </div>
        );
      },
    },
  ];

  const columnsFurnace = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.entry_date"),
      dataIndex: "tempered.start",
      key: "tempered.start",
      render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.exit_date"),
      dataIndex: "tempered.time",
      key: "tempered.time",
      render: (time, record) => {
        let start = record.tempered.start;
        let sec = start.unix();
        return moment((sec + time) * 1000).format("DD/MM/YYYY HH:mm:ss");
        //time.format("HH:mm:ss");
      },
    },
    {
      title: t("table.header.remaining_time"),
      dataIndex: "tempered.time",
      key: "tempered.temperature",
      render: (time, record) => {
        let start_sec = record.tempered.start.unix();
        let end_sec = start_sec + time;
        let plusTime = record.tempered.plusTime ? record.tempered.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo
        //this_sec += 7000 //Prueba de color
        let difference = end_sec - this_sec;
        let negative = difference < 0;

        return negative ? <h3 style={{ color: "red" }}>{"- " + secons2text(-1 * difference)}</h3> : <h3>{secons2text(difference)}</h3>;

        //return <h3>{secons2Dhm(end_sec-this_sec)}</h3>
        //time.format("HH:mm:ss");
      },
    },
    {
      title: t("table.header.action"),
      dataIndex: "tempered",
      key: "tempered",
      render: (text, record) => {
        let start_sec = record.tempered.start.unix();
        let end_sec = start_sec + record.tempered.time;

        let plusTime = record.tempered.plusTime ? record.tempered.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo
        let difference = end_sec - this_sec;
        let disabled = difference > 0;

        return (
          <div
            style={
              {
                /*width: 170*/
              }
            }
          >
            <Button type="link" size="small" disabled={disabled} onClick={() => article2out(record.id, record.name)}>
              {t("button.action.take")}
              <Icon type="right" />
            </Button>
          </div>
        );
      },
    },
  ];

  const article2furnace = (id, name) => {
    let order = manufacturingOrder.find((obj) => obj.name === name);
    let list = order.pieces.map((obj) => {
      if (obj.id === id) {
        return {
          ...obj,
          tempered: {
            start: moment(),
          },
        };
      } else return obj;
    });
    order.pieces = list;
    updateData(order);
  };

  const article2out = (id, name) => {
    let order = manufacturingOrder.find((obj) => obj.name === name);
    let list = order.pieces.map((obj) => {
      if (obj.id === id) {
        return {
          ...obj,
          tempered: {
            ...obj.tempered,
            end: moment(),
          },
        };
      } else return obj;
    });
    order.pieces = list;
    updateData(order);
  };

  const timeRunTempered = (seconds) => {
    manufacturingOrder.forEach((order) => {
      if (order.making) {
        let list = order.pieces.map((obj) => {
          if (obj.tempered && obj.tempered.start && !obj.tempered.end) {
            let plusTime = obj.tempered.plusTime ? obj.tempered.plusTime : 0;

            return {
              ...obj,
              tempered: {
                ...obj.tempered,
                plusTime: plusTime + seconds,
              },
            };
          } else return obj;
        });
        order.pieces = list;
        updateData(order);
      }
    });
  };

  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={8} lg={10} md={24}>
          <H3>{t("headers.control_process.available_pieces_quenching", { value: availableArticle && availableArticle.length })}</H3>
          <Table data={availableArticle} columns={columnsAvailable} size="small" pagination={{ pageSize: 15 }} />
        </Col>
        <Col xl={2} lg={4} md={24} style={{ height: "calc(70vh)" }}>
          <H3>{t("headers.control_process.status")}</H3>
          <Col span={24}>
            <Statistic
              title={t("labels.state.furnace_temp")}
              value={furnaceNowTemperature}
              precision={2}
              valueStyle={{ color: furnaceNowTemperature !== temperaturePrograming ? Colors.primary : Colors.success }}
              prefix={furnaceNowTemperature !== temperaturePrograming && <Icon type="arrow-up" />}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.programed_temp")}
              value={temperaturePrograming}
              precision={2}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
        </Col>
        <Col xl={14} lg={10} md={24} style={{ height: "calc(60vh - 210px)" }}>
          <Row>
            <Col span={8}></Col>
            <Col span={8}>
              <H3>{t("headers.control_process.pieces_in_furnace", { value: furnaceArticle && furnaceArticle.length })}</H3>
            </Col>
            <Col span={8}>
              <Button type="link" size="small" style={{ float: "right" }} onClick={() => timeRunTempered(600)}>
                <Icon type="clock-circle" />
                {t("button.advance_time", { time: 10 })}
              </Button>
            </Col>
          </Row>
          <Table data={furnaceArticle} columns={columnsFurnace} pagination={{ pageSize: 5 }} size="small" />
        </Col>
        <Col xl={14} lg={24} md={24}>
          <H3>{t("headers.control_process.manufacturing_order")}</H3>
          <Table data={manufacturingList} columns={columnsOrders} pagination={{ pageSize: 4 }} size="small" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default RenderTempered;
